import { selectCurrentUserId } from '@/features/app/selectors';
import { supabase } from '@/integrations/supabase/client';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useShowMessageNotification } from './useShowMessageNotification';
// import { getUserById } from '@/api/requests/endpoints/GET/getUser';
import { useLocation } from 'react-router-dom';
import { APP_ROUTES } from '@/utils/appRoutes';

export const useMessagesWatcher = () => {
  const currentUserId = useSelector(selectCurrentUserId);
  const dispatch = useDispatch();
  const showMessageNotification = useShowMessageNotification();
  const location = useLocation();

  useEffect(() => {
    if (!currentUserId || location.pathname.includes(APP_ROUTES.MESSAGES))
      return;

    const subscription = supabase
      .channel(`messages-${currentUserId}`)
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'messages',
          filter: `sender_id=neq.${currentUserId}`,
        },
        async (payload) => {
          const { new: newMessage } = payload;
          const { content, chat_id, sender_id } = newMessage;
          // const { data: isUserInChat } = await getIsUserIsInChat(
          //   chat_id,
          //   currentUserId,
          // );
          // if (!isUserInChat) return;
          // const { data } = await getUserById(sender_id);
          // if (data)
          //   showMessageNotification({
          //     senderName: data.first_name,
          //     messageContent: content,
          //     chatId: chat_id,
          //     avatarUrl: data.avatar_url,
          //   });
        },
      )
      .subscribe();

    return () => {
      supabase.removeChannel(subscription);
    };
  }, [currentUserId, location.pathname, dispatch, showMessageNotification]);
};
